module.exports = __webpack_public_path__ + "img/sec_in_device5.a5df2a57.png";